import _ from 'lodash'
import { connect } from 'react-redux'
import classNames from 'classnames'
import Cookies from 'js-cookie'
import Editor from './Editor'
import Icon from '../Icon'
import Preview from './Preview'
import React, { Component } from 'react'
import request from 'superagent'

if (process.env.BROWSER) require('../../styles/EditorView.less')

@connect(state => state)
class EditorView extends Component {

  constructor (props) {
    super()

    this.state = {
      countRender: 0,
      createTemplate: true,
      dimensions: null,
      html: props.editor.html,
      errors: props.editor.errors,
      isDesktopSize: true,
      scrollTop: 0,
      showWidget: false,
      templateID: props.editor.templateID || null,
      uiSize: 'middle',
      value: props.editor.value,
      mjmlVersion: null,
      minify: false,
      windowSize: null
    }
  }

  componentDidMount () {
    this.debouncedHandleWindowResize = _.debounce(this.handleWindowResize, 100)
    this.loadMjmlVersion()

    this.handleWindowResize()
    window.addEventListener('resize', this.debouncedHandleWindowResize)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.debouncedHandleWindowResize)
  }

  loadMjmlVersion() {
    request
      .get('/mjmlVersion')
      .end((err, res) => {
        if (err) return
        this.setState({ mjmlVersion: res.text })
      })
  }

  handleWindowResize = () => {
    const { uiSize } = this.state

    const windowSize ={
      height: window.innerHeight,
      width: window.innerWidth
    }
    const isDesktopSize = windowSize.width >= 800
    const dimensions = {
      height: this.editorView.clientHeight,
      width: this.editorView.clientWidth
    }

    this.setState({
      dimensions,
      isDesktopSize,
      uiSize: uiSize === 'middle' && !isDesktopSize ? 'left' : uiSize,
      windowSize
    })
  }

  handleChange = value => {
    this.setState({ value }, () => {
      this.renderToHTML(value)
    })
    this.debounceSaveTemplate(value)
  }

  handleResize (uiSize) {
    if (uiSize !== this.state.uiSize) {
      const { isDesktopSize } = this.state

      if (isDesktopSize) {
        uiSize = ['left', 'right'].includes(this.state.uiSize) ? 'middle' : uiSize
      }

      this.setState({ uiSize })
    }
  }

  handleScroll = scrollTop => this.setState({ scrollTop })

  handleCloseWidget = () => {
    Cookies.set('dismiss-popin', true)

    this.setState({ showWidget: false })
  }

  toggleMinify() {
    const { minify, value } = this.state
    this.setState({ minify: !minify }, () => {
      this.renderToHTML(value)
    })
  }

  debounceSaveTemplate = _.debounce(value => {
    const { editor } = this.props
    const { createTemplate } = this.state

    if (createTemplate) {
      request
        .post('/api/templates')
        .type('json')
        .set('X-CSRF-Token', editor.csrfToken)
        .send({ mjml: value })
        .end((err, res) => {
          const { templateID } = res.body

          if (templateID && (!this.state.templateID || this.state.templateID !== templateID)) {
            history.pushState(null, null, `/try-it-live/${templateID}`)
          }

          this.setState({
            createTemplate: false,
            templateID
          })
        })
    } else {
      request
        .put(`/api/templates/${this.state.templateID}`)
        .type('json')
        .set('X-CSRF-Token', editor.csrfToken)
        .send({ mjml: value })
        .end()
    }
  }, 1e3)

  renderToHTML (value) {
    const { editor } = this.props
    const { minify } = this.state

    request
      .post('/api/mjml')
      .type('json')
      .set('X-CSRF-Token', editor.csrfToken)
      .send({ mjml: value, minify })
      .end((err, res) => {
        if (!err) {
          const { html, errors } = res.body
          const countRender = this.state.countRender + 1

          this.setState({
            countRender,
            html,
            errors,
          })
        } else {
          console.log(err)
        }
      })
  }

  getHeight () {
    const { dimensions } = this.state

    if (dimensions !== null) {
      return `${parseInt(dimensions.height) - 56}px` // Header height
    }

    return '100%'
  }

  getWidth () {
    const { dimensions } = this.state

    if (dimensions !== null) {
      return `${parseInt(dimensions.width)}px`
    }

    return '100%'
  }

  render () {
    const { editor } = this.props
    const { value, uiSize, html, errors, scrollTop, templateID, showWidget, isDesktopSize, minify, mjmlVersion } = this.state

    return (
      <div
        className="EditorView"
        ref={r => this.editorView = r}>
        <div className={classNames('EditorView-Logo', { 'margin-left': uiSize === 'right' })}>
          <a href="/">
            <Icon
              name="mjml"
              text={isDesktopSize}
              white />
          </a>
          { mjmlVersion &&
            <a href="https://github.com/mjmlio/mjml/releases" target="_blank">
              <span className="EditorView-Version">
                version { mjmlVersion }
              </span>
            </a>
          }
        </div>
        <div className={classNames('EditorView-Left', { hidden: uiSize === 'right' })}>
          <Editor
            elements={editor.elements}
            height={this.getHeight()}
            onChange={this.handleChange}
            onScroll={this.handleScroll}
            uiSize={uiSize}
            value={value}
            errors={errors} />
        </div>
        <div className={classNames('EditorView-Resize', { [uiSize]: true })}>
          { uiSize !== 'right' &&
            <div
              className="EditorView-Resize-Left"
              onClick={this.handleResize.bind(this, 'right')}>
              <i className="ion ion-arrow-left-b" />
            </div> }
          { uiSize !== 'left' &&
            <div
              className="EditorView-Resize-Right"
              onClick={this.handleResize.bind(this, 'left')}>
              <i className="ion ion-arrow-right-b" />
            </div> }
        </div>
        <div className={classNames('EditorView-Right', { hidden: uiSize === 'left' })}>
          <Preview
            height={this.getHeight()}
            html={html}
            scrollTop={scrollTop}
            uiSize={uiSize}
            minify={minify}
            toggleMinify={this.toggleMinify.bind(this)}
            width={this.getWidth()} />
        </div>
      </div>
    )
  }

}

export default EditorView
